<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        L’enthalpie de mise en solution d’un sel peut être calculée à partir de son énergie
        réticulaire et de l’énergie d’hydratation individuelle de ses ions gazeux. Utilisez
        l’information dans le tableau pour calculer:
      </p>

      <v-simple-table class="pl-4 mb-6" style="max-width: 580px">
        <thead>
          <tr>
            <td>
              <stemble-latex content="$\textbf{Quantité}$" />
            </td>
            <td style="text-align: right">
              <stemble-latex content="$\textbf{Changement}$" />
              <stemble-latex content="$\textbf{d'enthalpie}$" />
              <stemble-latex content="$\text{(kJ/mol)}$" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>L’énergie réticulaire du chlorure d’ammonium</td>
            <td style="text-align: right">
              <stemble-latex content="$705$" />
            </td>
          </tr>

          <tr>
            <td>L’énergie réticulaire du nitrate d’ammonium</td>
            <td style="text-align: right">
              <stemble-latex content="$646$" />
            </td>
          </tr>

          <tr>
            <td>L’énergie d’hydratation de l’ion ammonium gazeux</td>
            <td style="text-align: right">
              <stemble-latex content="$-307$" />
            </td>
          </tr>

          <tr>
            <td>L’énergie d’hydratation de l’ion chlorure gazeux</td>
            <td style="text-align: right">
              <stemble-latex content="$-381$" />
            </td>
          </tr>

          <tr>
            <td>L’énergie d’hydratation de l’ion nitrate gazeux</td>
            <td style="text-align: right">
              <stemble-latex content="$-314$" />
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <p class="mb-2">a) L’enthalpie de mise en solution du chlorure d’ammonium solide</p>

      <calculation-input
        v-model="inputs.HsolnNH4Cl"
        prepend-text="$\Delta\text{H}^\circ_{\text{soln}}:$"
        append-text="$\text{kJ/mol}$"
        class="mb-5"
        :disabled="!allowEditing"
      />

      <p class="mb-2">b) L’enthalpie de mise en solution du nitrate d’ammonium solide</p>

      <calculation-input
        v-model="inputs.HsolnNH4NO3"
        prepend-text="$\Delta\text{H}^\circ_{\text{soln}}:$"
        append-text="$\text{kJ/mol}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'UOttawaPrelab2Q3Fr',
  components: {
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        HsolnNH4Cl: null,
        HsolnNH4NO3: null,
      },
    };
  },
};
</script>
